import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function AboutSean() {
  return (
    <section id="about" className="py-24 bg-white border-t border-brand-brown/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-brand-cream rounded-[2.5rem] overflow-hidden shadow-xl border-2 border-brand-brown/10">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-10 md:p-20 flex flex-col justify-center">
              <span className="text-brand-blue font-black tracking-[0.2em] uppercase text-xs mb-6 block">The Initiative</span>
              <h2 className="text-4xl md:text-5xl font-black text-brand-brown mb-8 leading-tight uppercase italic">
                Local trades. <br/> Shared reach.
              </h2>
              <div className="space-y-6 text-brand-brown/80 text-lg leading-relaxed font-medium">
                <p>
                  I'm Sean, a West Valley small business owner with a background in commercial printing. I know how hard it is to compete for attention when you're up against national chains and big ad budgets.
                </p>
                <p>
                  <strong>Mailbox Digital</strong> isn't an agency. It's a co-op I started to give local home service businesses the same visibility as the big guys — at a fraction of the cost by sharing it.
                </p>
                <p>
                  We aren't competing with each other — that's why I enforce strict category exclusivity. One plumber, one roofer, one landscaper. When your neighbor wins a job, you're next. Let's own the West Valley mailboxes together.
                </p>
              </div>

              <div className="mt-12 flex items-center gap-6 p-6 bg-white rounded-2xl border border-brand-brown/10 shadow-sm">
                <div className="flex -space-x-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="w-12 h-12 rounded-full border-4 border-white overflow-hidden bg-brand-cream">
                      <img src={`https://i.pravatar.cc/150?u=trade${i}`} alt="Owner" className="w-full h-full object-cover" />
                    </div>
                  ))}
                </div>
                <div>
                  <p className="text-sm font-black text-brand-brown uppercase tracking-tight">Join the Home Services Collective</p>
                  <p className="text-xs font-bold text-brand-brown/50 uppercase tracking-widest">West Valley Trades Only</p>
                </div>
              </div>
            </div>

            <div className="relative h-80 lg:h-auto overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
                alt="Home services contractor at work"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-brand-cream via-transparent to-transparent hidden lg:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
